import * as React from 'react';
import { useState, useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import Button from '@mui/material/Button';
import {ArrowBackIos} from "@mui/icons-material";
import TextField from '@mui/material/TextField';
import { Spin, Divider, Alert, Card } from 'antd';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';


const Login = ({isProspect, onBack}) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { handleLogin, loginFailed } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    handleLogin(username, isProspect ? 'tracker' : password);
    setLoading(false);
  };

  return (
    <div>

      <Divider/>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1, maxWidth: 600 }}>
          <TextField
            margin="large"
            size={'small'}
            required
            fullWidth
            placeholder={'username@email.com'}
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
          {!isProspect && ( // Only show the password field if not a prospect login
            <TextField
              margin="normal"
              size={'small'}
              required
              fullWidth
              placeholder={'Password'}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          )}
          <FormControlLabel
            control={<Checkbox value="remember" style={{borderColor: 'red', color: '#868b98'}} />}
            label="Remember me"
            style={{color: '#868b98'}}
          />
          {loginFailed===true && (
              <>
                <Alert style={{fontWeight: '600'}} message="Username or Password Not Found" type="error" showIcon />
              </>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, background: "rgba(0, 0, 0, 0.5)", pt: 1, pb: 1 }}
            startIcon={loading ? <Spin/>:null}
          >
            {loading ? 'Loading' : 'Sign In'}
          </Button>
        </Box>
    </div>
  );
};

export default Login;
